import { connect } from 'react-redux'
import { getEntries } from 'features/Cms/Cms.actions'
import BlogArticles from './BlogArticles'
import { filterAndOrderBlogs } from '../../../Blog/Blog.utils'

const stateToProps = ({ cms }, props) => {
  const { slugFilter, categoryFilter, authorFilter } = props
  const allArticles = cms.blogPost || []

  const horizontal = slugFilter ? true : props.horizontal

  const filteredArticles = filterAndOrderBlogs(allArticles).filter(article => {
    // filter by slug
    if (slugFilter) {
      return article.fields.slug === slugFilter
    }

    const categories = article.fields.categories.map(item => item.fields.name) || []

    // filter by category
    const categoryMatch = categoryFilter ? categories.includes(categoryFilter) : true

    // filter by author
    const authorMatch = authorFilter ? article.fields.author.fields.name === authorFilter : true

    return categoryMatch && authorMatch
  })

  return {
    articles: filteredArticles.slice(0, horizontal ? 1 : 3),
    horizontal,
  }
}

const dispatchToProps = {
  getArticles: () => getEntries({ contentType: 'blogPost' }),
}

export default connect(stateToProps, dispatchToProps)(BlogArticles)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/BlogArticles/BlogArticles.container.js